/**
 * Generates a short unique string
 *
 * This generates a random string with varying length that always starts with a letter.
 * Don't use this for tokens requiring security or uniqueness in large sets.
 */
export const generateRandomToken = () => (Math.random() + 1).toString(36);
